/**
 * Creates an onChange handler that restricts input to a maximum number of decimal places
 * @param {Function} callback - The original onChange handler to call if validation passes
 * @param {number} maxDecimalPlaces - Maximum number of decimal places allowed (default: 2)
 * @returns {Function} - A new onChange handler with decimal place restriction
 */
export const handleDecimalInput = (callback, maxDecimalPlaces = 2) => (e) => {
    const value = e.target.value || e.currentTarget.value;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${maxDecimalPlaces}}$`);
    
    if (value === '' || regex.test(value)) {
        callback(e);
    }
};

/**
 * Validates if a value has at most the specified number of decimal places
 * @param {string|number} value - The value to validate
 * @param {number} maxDecimalPlaces - Maximum number of decimal places allowed (default: 2)
 * @returns {boolean} - True if valid, false otherwise
 */
export const isValidDecimalPlaces = (value, maxDecimalPlaces = 2) => {
    if (value === '' || value === null || value === undefined) return true;
    const regex = new RegExp(`^\\d*\\.?\\d{0,${maxDecimalPlaces}}$`);
    return regex.test(String(value));
};
